import {useState, useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {push} from 'connected-react-router'
import styled from 'styled-components'
// Firestore
import { db } from '../firebase'
// Components
import { Layout, PrimaryButton, TextDetail } from '../components'
// Mui
import Button from '@material-ui/core/Button'
// Reducks
import { getUserId } from '../reducks/users/selectors'

const Profile = () => {

    const dispatch = useDispatch()
    const selector = useSelector(state=>state)
    const userId = getUserId(selector)

    const [lastname, setLastname] = useState('')
    const [firstname, setFirstname] = useState('')
    const [postalCode, setPostalCode] = useState('')
    const [prefecture, setPrefecture] = useState('')
    const [city, setCity] = useState('')
    const [street, setStreet] = useState('')
    const [tel, setTel] = useState('')

    useEffect(()=>{
        if(userId){
            db.collection('users').doc(userId).get()
              .then(doc => {
                    const data = doc.data()
                    setLastname(data.lastname)
                    setFirstname(data.firstname)
                    setPostalCode(data.postalCode)
                    setPrefecture(data.prefecture)
                    setCity(data.city)
                    setStreet(data.street)
                    setTel(data.tel)
              })
        }
        return null
    },[userId])

    return (
        <Layout>
            <div className='spacer-50' />
            <h1 style={{textAlign: 'center'}}>プロフィール</h1>
            <div className='spacer-50' />

            <Wrapper>
                <TextDetail label={'お名前'} value={lastname && firstname ? lastname + " " + firstname : "未登録"} />
                <TextDetail label={'ご住所'} value={postalCode && prefecture && city && street ? "〒" + postalCode + " " + prefecture + city + street : "未登録"} />
                <TextDetail label={'電話番号'} value={tel ? tel : "未登録"} />
            </Wrapper>

            <div className='spacer-50' />

            <div style={{textAlign: 'center'}}>
                <PrimaryButton label='プロフィールを編集する' operation={()=>dispatch(push('/profile/edit'))} />
                <div className='spacer-25' />
                <Button onClick={()=>dispatch(push('/mypage'))}>マイページに戻る</Button>
            </div>

            <div className='spacer-100' />
        </Layout>
    )
}

export default Profile

const Wrapper = styled.div`
    width: 480px;
    margin: 0 auto;
    @media screen and (max-width:768px){
        width: 100%;
        padding: 0 20px;
    }
`